import { IconChevronRight } from "../icon/variants/IconChevronRight.js";
import { Text as Text$1 } from "../mantine-passthroughs/index.js";
import { getColor } from "../typography/shared.js";
import { Anchor as Anchor$1 } from "../anchor/Anchor.js";
import { Body1 } from "../typography/Body1.js";
import { Breadcrumbs } from "@mantine/core";
import { Fragment, useMemo } from "react";
import { Fragment as Fragment$1, jsx } from "react/jsx-runtime";
import { useLocation } from "react-router-dom";

//#region src/components/breadcrumbs/Breadcrumbs.tsx
const Breadcrumbs$1 = ({ items, "data-testid": testId }) => {
	const renderBreadcrumbItem = (title, href, isCurrentPage, bold) => /* @__PURE__ */ jsx(Fragment$1, { children: isCurrentPage ? /* @__PURE__ */ jsx(Text$1, {
		size: "lg",
		fw: bold ? 600 : 400,
		style: {
			color: getColor("gray", true),
			textWrap: "pretty"
		},
		children: title
	}) : /* @__PURE__ */ jsx(Anchor$1, {
		textDecoration: "none",
		href,
		children: /* @__PURE__ */ jsx(Body1, {
			color: "primary",
			children: title
		})
	}, href) });
	const { pathname } = useLocation();
	const breadcrumbItems = useMemo(() => {
		const boldCurrentPage = items.length > 1;
		return items.map((item) => {
			const isCurrentPage = item.href === pathname;
			return renderBreadcrumbItem(item.title, item.href, isCurrentPage, boldCurrentPage);
		});
	}, [items, pathname]);
	if (!items || items.length === 0) return null;
	return /* @__PURE__ */ jsx(Breadcrumbs, {
		separatorMargin: "xxxs",
		separator: /* @__PURE__ */ jsx(IconChevronRight, {}),
		"data-testid": testId,
		children: breadcrumbItems.map((item, index) => /* @__PURE__ */ jsx(Fragment, { children: item }, index))
	});
};

//#endregion
export { Breadcrumbs$1 as Breadcrumbs };